import { useEffect, useState } from "react";
import CanvasSection from "./CanvasSection";
import Footer from "./Footer";
import Header from "./Header";
import NavBar from "./NavBar";
import { useStickerSectionStore } from "../EditorStore";
import { ImageStore } from "../ImageStore";
import { applyOrganicEdge } from "../utils/organicEdge";
import { isHeicFile, convertHeicToPng } from "../utils/heicConversion";

export default function MainEditor() {

    const setToolTipShown = useStickerSectionStore((state) => state.setTutorialToolTipShown)
    const [showDropError, setShowDropError] = useState(false)

    useEffect(() => {
        const handleTouchOutside = () => {
            setToolTipShown(true)
        };

        document.addEventListener("touchstart", handleTouchOutside);
        return () => document.removeEventListener("touchstart", handleTouchOutside);
    }, []);

    const handleDragOver = (e: React.DragEvent) => {
        e.preventDefault();
    };

    const handleDrop = async (e: React.DragEvent) => {
        e.preventDefault();


        const extractedFiles: File[] = [];
        const items = e.dataTransfer.items;

        if (items && items.length > 0) {
            for (const item of Array.from(items)) {
                if (item.kind === "file") {
                    const file = item.getAsFile();
                    if (file) extractedFiles.push(file);
                }
            }
        }

        if (extractedFiles.length === 0) {
            const files = e.dataTransfer.files;
            if (files && files.length > 0) {
                extractedFiles.push(...Array.from(files));
            }
        }

        if (extractedFiles.length === 0) return;

        if (extractedFiles.some(f => f.size === 4)) {
            setShowDropError(true);
            setTimeout(() => setShowDropError(false), 3500);
            return;
        }

        for (const file of extractedFiles) {
            try {
                let processedFile: File;

                if (isHeicFile(file)) {
                    const pngBlob = await convertHeicToPng(file);

                    processedFile = new File(
                        [pngBlob],
                        file.name.replace(/\.(heic|heif)$/i, ".png"),
                        { type: "image/png" }
                    );
                } else {
                    processedFile = file;
                }

                const smoothedFile = await applyOrganicEdge(processedFile);

                await ImageStore.addImage(smoothedFile);

            } catch (err) {
                console.error("Failed to process dropped image:", err);
            }
        }
    };

    return (
        <div
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            style={{
                position: "relative",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                touchAction: "none"
            }}
        >
            {showDropError && (
                <div style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(200, 0, 0, 0.85)",
                    zIndex: 999999,
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "18px",
                    fontWeight: 600,
                    textAlign: "center",
                    padding: "20px",
                    paddingBottom: "15%",
                    pointerEvents: "none"
                }}>
                    Please make sure you are going to step 3 in the tutorial.
                </div>
            )}
            <Header />
            <NavBar />
            <CanvasSection />
            <Footer />

        </div>
    );
}
